import { useState, useEffect, useCallback } from 'react';
import { RequestService } from '../services/requestService';
import { ServiceRequest } from '../models/ServiceRequest';

export function useRequests() {
  const [requests, setRequests] = useState<ServiceRequest[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [totalCount, setTotalCount] = useState(0);

  const fetchRequests = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await RequestService.getAllRequests();
      
      if (response.success && response.data) {
        setRequests(response.data.serviceRequests || []);
        setTotalCount(response.data.pagination?.totalCount || 0);
      } else {
        setRequests([]);
        setTotalCount(0);
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch requests';
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const updateRequestStatus = useCallback(async (requestId: string, status: string) => {
    try {
      await RequestService.updateRequestStatus(requestId, status);
      // Refresh the requests list after updating
      await fetchRequests();
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to update request status';
      setError(errorMessage);
      console.error('Error updating request status:', err);
    }
  }, [fetchRequests]);

  // Fetch requests on mount
  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);

  return {
    requests,
    isLoading,
    error,
    totalCount,
    fetchRequests,
    updateRequestStatus,
  };
}
